/* eslint-disable consistent-return */
import { Button, Grid, IconButton } from '@material-ui/core';
import { Delete, Check, Add, Close } from '@material-ui/icons';

import {
  deleteManyStudentCompetencePro,
  deleteStudentCompetencePro,
  getJobBigDomains,
  getJobs,
  getJobsBySector,
  getJobSectors,
  getJobSectorsByDomain,
  getSkillCategory,
  getSkillsByJobOgr,
  getStudentSkillsPro,
  postManyStudentCompetencePro,
  postStudentCompetencePro,
  updateStudentCompetencePro,
} from '@webapps/business';
import {
  FormikAutocomplete,
  FormikAutocompletePx,
  FormikTextField,
  Loader,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { label } from 'aws-amplify';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import { domain } from 'process';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import { useMemo } from 'react';

const competenceSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  level: yup.number().typeError('Vous devez renseigner un chiffre entre 1 et 5').required('Requis'),
  category: yup.object().shape({
    id: yup.string(),
  }),
});

const AddCompetence = ({
  close,
  refetch,
  initialData = {},
  editCategory = false,
  isLoadingEdit,
  idEdit,

}) => {
  const {
    css,
    global,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateCompetencePro,
  } = useMutation(postStudentCompetencePro);

  const {
    isLoading: isLoadingUpdate,
    isSuccess: isSuccessUpdate,
    mutateAsync: mutateUpdateCompetencePro,
  } = useMutation(updateStudentCompetencePro);

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteCompetencePro,
  } = useMutation(deleteStudentCompetencePro);

  // updateStudentCompetencePro

  const [skillAdded, setSkillAdded] = useState([]);
  const [pendingSkills, setPendingSkills] = useState([]); // Pour stocker les compétences en attente d'enregistrement
  const [pendingDeleteSkills, setPendingDeleteSkills] = useState([]); // Compétences à supprimer
  const [resetCombinedSkills, setResetCombinedSkills] = useState(false);
  const { mutateAsync: postSkills } = useMutation(postManyStudentCompetencePro);
  // const { mutateAsync: deleteSkill } = useMutation(deleteStudentCompetencePro);

  const { addToast } = useToast();

  const { data: bigDomains = [] } = useQuery(getJobBigDomains, {
    key: 'bigDomains',
  });

  const { data: { content: skillCategory } = {} } = useQuery(getSkillCategory, {
    key: 'skillCategory',
  });

  const { data: userSkills = [], refetch: refetchUserSkills } = useQuery(getStudentSkillsPro, {
    key: 'userSkills',
    variables: {
      id: idUser,
    },
  });

  useEffect(() => {
    if (isSuccess || isSuccessUpdate || isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
      setResetCombinedSkills(true);
    }
  }, [isSuccess, isSuccessUpdate, isSuccessDelete]);

  const formik = useFormik({
    initialValues: {
      label: initialData.label || '',
      bigDomains: {
        code: initialData?.job?.bigDomain?.code || '',
      },
      jobSector: {
        id: initialData?.job?.jobSector?.skill_category_id || '',
      },
      category: {
        id: initialData?.category?.id || '',
      },
      job: {
        ogr: initialData?.job?.id || '',
      },
      skills: initialData?.skills || [],
      level: initialData?.level || '',
    },
    enableReinitialize: true,
    validationSchema: competenceSchema,
    onSubmit: async (values) => {
      if (idEdit) {
        await mutateUpdateCompetencePro({
          data: values,
          id: idEdit,
        });
      } else {
        await mutateCompetencePro({
          data: values,
          id: idUser,
        });
      }
    },
  });

  const { data: jobSector = [], refetch: refetchJobSector } = useQuery(getJobSectorsByDomain, {
    key: 'jobSector',
    variables: {
      domain: formik?.values?.bigDomains?.code,
    }
  });

  useEffect(() => {
    if (formik?.values?.bigDomains?.code) {
      refetchJobSector();
    }
  }, [formik?.values?.bigDomains?.code, refetchJobSector]);

  const { data: job = [], refetch: refetchJob } = useQuery(getJobsBySector, {
    key: 'job',
    variables: {
      sector: formik?.values?.jobSector?.id,
    },
    enabled: !!formik?.values?.jobSector?.id, // Assurez-vous que la requête ne se déclenche que si un secteur est défini
  });

  useEffect(() => {
    if (formik?.values?.jobSector?.id) {
      refetchJob();
    }
  }, [formik?.values?.jobSector?.id, refetchJob]);


  // Utiliser un état pour stocker l'OGR du job sélectionné
  const [selectedJobOgr, setSelectedJobOgr] = useState(formik?.values?.job?.ogr || '');

  // Mettre à jour la requête pour utiliser selectedJobOgr au lieu de formik?.values?.job?.ogr
  const { data: skills = [], refetch: refetchSkills } = useQuery(getSkillsByJobOgr, {
    key: ['skills', selectedJobOgr], // Utiliser selectedJobOgr dans la clé pour forcer le rafraîchissement
    variables: {
      jobOgr: selectedJobOgr,
    },
    enabled: !!selectedJobOgr, // N'exécuter la requête que si selectedJobOgr est défini
  });

  // Mettre à jour selectedJobOgr lorsque formik?.values?.job change
  useEffect(() => {
    if (formik?.values?.job?.ogr) {
      setSelectedJobOgr(formik?.values?.job?.ogr);
    }
  }, [formik?.values?.job]);

  const combinedSkills = useMemo(() => {
    if (resetCombinedSkills) return []; // Si on réinitialise, retourner une liste vide

    return skills.map((skill) => ({
      ...skill,
      isUserSkill: !!userSkills.find((userSkill) => userSkill.label === skill.label),
      id: userSkills.find((userSkill) => userSkill.label === skill.label)?.id || null,
      level: userSkills.find((userSkill) => userSkill.label === skill.label)?.level || 1,
    }));
  }, [skills, userSkills, resetCombinedSkills]); // Ajoutez `resetCombinedSkills` à la dépendance


  const deleteSkill = async () => {



    await mutateDeleteCompetencePro({
      id: idEdit,
    });
  };

  if (isLoadingEdit) {
    return <Loader />;
  }

  const handleAddSkill = (skill) => {
    if (!pendingSkills.some(({ skillCode }) => skillCode === skill.skillCode)) {
      setPendingSkills([...pendingSkills, skill]);
    }
  };
  const handleDeleteUserSkill = (skill) => {


    if (!pendingDeleteSkills.some(({ id }) => id === skill.id)) {
      setPendingDeleteSkills([...pendingDeleteSkills, skill]);
    } else {
      setPendingDeleteSkills(pendingDeleteSkills.filter(({ id }) => id !== skill.id));
    }
  };


  const handleRemoveSkill = (skillCode) => {
    setPendingSkills(pendingSkills.filter((skill) => skill.skillCode !== skillCode));
  };



  const handleSaveSkills = async () => {
    try {
      // Ajouter toutes les compétences, qu'elles soient nouvelles ou modifiées
      const skillsToAdd = pendingSkills.map((skill) => ({
        label: skill.label,
        category: {
          id: jobSector.find(
            ({ skill_category_id }) => skill_category_id === formik.values.jobSector.id
          )?.id,
        },
        level: skill.level, // Niveau modifié ou inchangé
        jobSectorSkill: {
          skillCode: skill.skillCode,
        },
        id: skill.id || undefined, // Inclure l'ID si c'est une compétence existante
      }));



      // Supprimer les compétences si nécessaire
      const skillsToDelete = pendingDeleteSkills.map(({ id }) => id);



      // Enregistrez les compétences ajoutées ou mises à jour
      if (skillsToAdd.length > 0) {
        await postManyStudentCompetencePro.query({
          data: skillsToAdd,
          id: idUser,
        });
      }

      // Supprimez les compétences si nécessaire
      if (skillsToDelete.length > 0) {
        await deleteManyStudentCompetencePro.query({
          data: skillsToDelete,
          id: idUser,
        });
      }

      addToast({ status: 'success', message: 'Modifications enregistrées avec succès.' });

      setPendingSkills([]);
      setPendingDeleteSkills([]);
      refetchUserSkills(); // Rafraîchir les compétences
      refetch();
      close();
      setResetCombinedSkills(true);
    } catch (error) {
      console.error('Erreur lors de l\'enregistrement des compétences:', error);
      addToast({ status: 'error', message: 'Erreur lors de l\'enregistrement.' });
    }
  };


  const handleEditSkill = () => {

  };

  return (
    <div>
      <Row>
        {!idEdit &&
          <Grid container spacing={2}>
            <Grid item xs={12}>

              <FormikAutocompletePx
                defaultValue=""
                disabled={editCategory ? true : idEdit}
                borderRadius={6}
                formik={formik}
                fullWidth
                getOptionLabel={(option) => option.label || ''}
                getOptionSelected={(option, value) => value.code === option.code}
                label={<FormattedMessage id="Domaine" />}
                name="bigDomains.code"
                options={bigDomains}
                pathValue="code"
                value={
                  bigDomains?.find(
                    ({ code }) => code === formik?.values?.bigDomains?.code
                  ) || null
                }
              />
            </Grid>
            {formik?.values?.bigDomains?.code !== '' && <Grid item xs={12}>

              <FormikAutocompletePx
                defaultValue=""
                disabled={editCategory ? true : formik?.values?.bigDomains?.code === ''}
                borderRadius={6}
                formik={formik}
                fullWidth
                getOptionLabel={(option) => option.label || ''}
                getOptionSelected={(option, value) => value.skill_category_id === option.skill_category_id}
                label={<FormattedMessage id="Secteur" />}
                name="jobSector.id"
                options={jobSector}
                pathValue="skill_category_id"
                value={
                  jobSector && jobSector?.find(
                    ({ skill_category_id }) => skill_category_id === formik?.values?.jobSector?.id
                  ) || null
                }
              />
            </Grid>}
            {formik?.values?.jobSector?.id !== "" && <Grid item xs={12}>
              <FormikAutocompletePx
                defaultValue=""
                disabled={formik?.values?.jobSector?.id === ''}
                borderRadius={6}
                formik={formik}
                fullWidth
                getOptionLabel={(option) => option.label || ''}
                getOptionSelected={(option, value) => value.ogr === option.ogr}
                label={<FormattedMessage id="Intitulé du post" />}
                name="job.ogr"
                options={job}
                pathValue="ogr"
                value={
                  job?.find(
                    ({ ogr }) => ogr === formik?.values?.job?.ogr
                  ) || null
                }
              />
            </Grid>}
            <Grid item xs={12}>
              {
                formik?.values?.job?.ogr ? (
                  combinedSkills.length > 0 ? (
                    <div>
                      {/* <p className={css({ textAlign: 'center' })}>Compétences</p> */}
                      <div
                        className={css({
                          display: 'flex',
                          flexWrap: 'wrap',
                          margin: 'auto',
                        })}
                      >
                        {combinedSkills.length > 0 ? (
                          <div>
                            <div className={global.title}
                              style={{
                                marginTop: '20px', marginBottom: '10px',
                                borderLeft: '3px solid #0060F9',
                                paddingLeft: 8,


                              }}
                            >
                              Compétences
                            </div>
                            <div
                              className={css({
                                display: 'flex',
                                flexWrap: 'wrap',
                                margin: 'auto',
                              })}
                            >
                              {combinedSkills.map((skill) => {
                                const isPendingAdd = pendingSkills.some(({ skillCode }) => skillCode === skill.skillCode);
                                const isPendingDelete = pendingDeleteSkills.some(({ id }) => id === skill.id);


                                const skillInPending = pendingSkills.find(({ skillCode }) => skillCode === skill.skillCode);
                                const skillLevel = skillInPending ? skillInPending.level : skill.level;







                                const handleLevelChange = (event) => {
                                  const newLevel = parseInt(event.target.value, 10);


                                  // Vérifier si la compétence est déjà dans pendingSkills
                                  const skillInPending = pendingSkills.find(({ skillCode }) => skillCode === skill.skillCode);

                                  if (skillInPending) {
                                    // Mettre à jour si déjà dans pendingSkills
                                    const updatedSkills = pendingSkills.map((pendingSkill) =>
                                      pendingSkill.skillCode === skill.skillCode
                                        ? { ...pendingSkill, level: newLevel }
                                        : pendingSkill
                                    );
                                    setPendingSkills(updatedSkills);
                                  } else {
                                    // Ajouter aux pendingSkills avec le nouveau niveau
                                    setPendingSkills([...pendingSkills, { ...skill, level: newLevel }]);
                                  }
                                };



                                return (
                                  <div
                                    key={skill.skillCode || skill.id}
                                    className={css({
                                      backgroundColor: skill.isUserSkill
                                        ? isPendingDelete
                                          ? '#F3F7FF' // Couleur pour suppression
                                          : '#C0D9FF'
                                        : isPendingAdd
                                          ? '#C0D9FF'
                                          : '#F3F7FF',
                                      color: '#152652',
                                      padding: '8px 12px',
                                      margin: '3px',
                                      borderRadius: '6px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      gap: '10px',
                                      transition: 'all 0.3s',
                                      // '&:hover': {
                                      //   backgroundColor: '#e0e8ff',
                                      // },
                                    })}
                                  >
                                    <p className={css({ fontSize: 13, margin: 0 })}>{skill.label}</p>
                                    <div className={css({ display: 'flex', alignItems: 'center', gap: '8px' })}>
                                      <select
                                        value={skillLevel} // Utilise la valeur calculée
                                        onChange={handleLevelChange} // Appelle le gestionnaire
                                        className={css({
                                          borderRadius: '4px',
                                          border: '1px solid #c0c0c0',
                                          padding: '4px',
                                          backgroundColor: 'white',
                                          color: '#152652',
                                          cursor: 'pointer',
                                          '&:focus': {
                                            outline: 'none',
                                            border: '1px solid #0275d8',
                                          },
                                        })}
                                      >
                                        {[1, 2, 3, 4, 5].map((level) => (
                                          <option key={level} value={level}>
                                            {level}
                                          </option>
                                        ))}
                                      </select>

                                      <span className={css({ color: '#F9B700', fontSize: '16px' })}>★</span>
                                      {skill.isUserSkill ? (
                                        <IconButton
                                          onClick={() =>
                                            isPendingDelete
                                              ? handleDeleteUserSkill(skill) // Retirer de la suppression
                                              : setPendingDeleteSkills([...pendingDeleteSkills, skill]) // Ajouter à la suppression
                                          }
                                          size="small"
                                          title={isPendingDelete ? 'Annuler la suppression' : 'Marquer pour suppression'}
                                        >
                                          {isPendingDelete ? (
                                            <Add fontSize="small" style={{ color: '#0275d8' }} />
                                          ) : (
                                            <Close fontSize="small" style={{ color: '#0275d8' }} />
                                          )}
                                        </IconButton>
                                      ) : isPendingAdd ? (
                                        <IconButton
                                          onClick={() => handleRemoveSkill(skill.skillCode)}
                                          size="small"
                                          title="Retirer de la liste d'ajout"
                                        >
                                          <Close fontSize="small" style={{ color: '#0275d8' }} />
                                        </IconButton>
                                      ) : (
                                        <IconButton
                                          onClick={() => handleAddSkill(skill)}
                                          size="small"
                                          title="Ajouter cette compétence"
                                        >
                                          <Add fontSize="small" style={{ color: '#0275d8' }} />
                                        </IconButton>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <p className={css({ textAlign: 'center' })}>Aucune compétence</p>
                        )}
                      </div>
                    </div>
                  ) : (
                    <p className={css({ textAlign: 'center' })}>Aucune compétence</p>
                  )) : (
                  <p className={css({ textAlign: 'center' })}>Veuillez sélectionner un métier</p>
                )}
            </Grid>
          </Grid>}
        {
          idEdit &&
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className={css({ marginBottom: '16px' })}>
                {formik?.values?.label}
              </div>
            </Grid>
            <Grid item xs={12}>
              <FormikTextField
                formik={formik}
                fullWidth
                label="Niveau"
                name="level"
                type="number"
                min={1}
                max={5}
                borderRadius={6}
              />
            </Grid>
          </Grid>
        }
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            {!idEdit &&
              <Button
                className={css({ borderRadius: '400px' })}
                color="primary"
                // disabled={}
                onClick={handleSaveSkills}
                variant="contained"
              >
                <FormattedMessage id="vitrine.btnCreate" />
              </Button>

            }
            {idEdit && (
              <>
                <Button
                  className={css({ borderRadius: '400px' })}
                  color="primary"
                  disabled={initialData?.level === formik?.values?.level}
                  onClick={formik.handleSubmit}
                  variant="contained"
                >
                  <FormattedMessage id="vitrine.btnCreate" />
                </Button>
                <Button
                  className={css({ borderRadius: '400px', marginLeft: spacing(1), backgroundColor: "#FBD3D5" })}
                  color="secondary"
                  disabled={isLoading || isLoadingUpdate || isLoadingDelete}
                  onClick={deleteSkill}
                  variant="outlined"
                >
                  <FormattedMessage id="btnDelete" />
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Row>
    </div >
  );
};

AddCompetence.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
  initialData: PropTypes.object,
  editCategory: PropTypes.bool,
  isLoadingEdit: PropTypes.bool,
  idEdit: PropTypes.string,
  allSkills: PropTypes.array,
};

export default AddCompetence;
